/* eslint-disable */
import * as React from "react";
import { SlideContext } from "../Context";
import { ComponentSourcetitle } from "../../../components/ComponentSourcetitle";
import { ComponentPreloader } from "../../../components/ComponentPreloader";
import { useChartHistoricalData } from "../data/useChartHistoricalData";
import { useHighchartHistoricalTransformer } from "../transformers/useHighchartHistoricalTransformer";
import { useHookSubscribe } from "../../../shared/hooks/hookSubscribe";
import HighchartsChart from "../../../../charts/components/HighchartsChart";
import { ComponentContextReadyState } from "@sa/rep-core";
import { ComponentTitle } from "../../../components/ComponentTitle";
import { ComponentFootnote } from "../../../components/ComponentFootnote";
import { useExportSource } from "../hooks/useExportSource";
import { useHistoricalFootnote } from "../hooks/useHistoricalFootnote";
import { useSubscriptionSource } from "../../../shared";

export const ComponentChartHistorical: React.FC<{ context: SlideContext }> = (props) => {
  const context = props.context;
  const olapResult = useHookSubscribe(null, context.olapResultHistorical$);
  const source = useHookSubscribe(null, context.sourcesHistorical$);
  const sourceForecast = useHookSubscribe(null, context.sourcesForecast$);
  const loading = useHookSubscribe(null, context.loading$);
  useExportSource([source, sourceForecast].join("; "));
  useSubscriptionSource([source, sourceForecast].join("; "));

  const chartData = useChartHistoricalData(olapResult);
  const highchartData = useHighchartHistoricalTransformer(chartData);
  const footnote = useHistoricalFootnote();

  if (window["exportMode"]) {
    window["exportReady"] = !loading;
  }

  if (loading) {
    return <ComponentPreloader />;
  }
  return (
    <>
      <ComponentTitle>Historical prices</ComponentTitle>
      <ComponentSourcetitle>Source: Historical - {source || "USDA Prices"}</ComponentSourcetitle>
      <HighchartsChart data={highchartData} loader={<ComponentPreloader />} />
      <ComponentFootnote>{footnote}</ComponentFootnote>
    </>
  );
};
